<!-- Dialog for deleting records when the user has not selected a record -->
<h2 mat-dialog-title style="font-weight:bold; color:#003865">Delete a record</h2>

<!-- Delete a record dialog -->
<mat-dialog-content class="mat-typography" style="color:#003865">

    <p>You must select a record in the table prior to deleting.</p>

</mat-dialog-content>

<!-- Close button -->
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
